import { colors } from '@mui/material';

export const ACTIVITY_BUCKETS = [
  {
    key: 'H00_24',
    maxHours: 24,
    label: 'Up to 1 day (Active)',
    shortLabel: 'Active',
    accentColor: colors.green[400],
  },
  {
    key: 'H24_48',
    maxHours: 48,
    label: '1 - 2 days (Slowing Down)',
    shortLabel: 'Slowing Down',
    accentColor: colors.amber[400],
  },
  {
    key: 'H48_120',
    maxHours: 120,
    label: '2 - 5 days (Stalled)',
    shortLabel: 'Stalled',
    accentColor: colors.red[400],
  },
  {
    key: 'H120_PLUS',
    maxHours: null,
    label: '5+ days (Critically Stalled)',
    shortLabel: 'Critically Stalled',
    accentColor: colors.grey[800],
  },
] as const;

export type ActivityBucket = typeof ACTIVITY_BUCKETS[number]['key'];
